export default __webpack_public_path__ + "img/srdekatlon.6fcd51d2.png";